import { Component, OnInit } from '@angular/core';
import { MenuComponent } from '../../../shared/components/menu/menu.component';
import { ModuloEnum } from '../../../shared/enums/modulo.enum';
import { FuncionalidadeEnum } from '../../../shared/enums/funcionalidade.enum';
import { Modulo } from '../../../shared/services/models/usuario-admin/modulo.model';

import { MatRippleModule } from '@angular/material/core';
import { RouterModule } from '@angular/router';
import { MatCardModule } from '@angular/material/card';
import { AuthService } from '../../../shared/services/apis/usuario-admin/auth.service';

@Component({
  selector: 'app-home',
  imports: [MenuComponent, RouterModule, MatCardModule, MatRippleModule],
  templateUrl: './home.component.html',
  styleUrl: './home.component.css',
})
export class HomeComponent implements OnInit {
  public moduloEnum: ModuloEnum;
  public funcionalidadeEnum: FuncionalidadeEnum;
  public listaModulos: Modulo[] = [];
  public nomeUsuario: string = '';

  constructor(private authService: AuthService) {
    this.moduloEnum = ModuloEnum.Home;
    this.funcionalidadeEnum = FuncionalidadeEnum.Master_Usuario;
  }

  ngOnInit(): void {
    const usuarioLoginResponse = this.authService.getUserInfos();

    if (usuarioLoginResponse && usuarioLoginResponse.listaModulos) {
      this.nomeUsuario = usuarioLoginResponse.nomeUsuarioAdmin;

      // Popula a lista de módulos para serem exibidos como atalhos
      this.listaModulos = usuarioLoginResponse.listaModulos;
    }
  }
}
